import React from "react";

import { Label, Link } from "@busbud/horizon";

import { useAppContext } from "@app/helpers/hooks";

import { useHepstarTermsAndConditions } from "./use-hepstar-terms-modal";

export const DefaultMessage = React.memo(() => {
  const openTermsAndConditions = useHepstarTermsAndConditions();
  const { translator } = useAppContext();

  return (
    <>
      {translator.t("!ancillary.hepstar-banner.text")}{" "}
      <Label as="p" size="md" fontWeight="bold">
        <Link
          disableUnderline
          role="button"
          onClick={() => openTermsAndConditions()}
        >
          {translator.t("!ancillary.hepstar-banner.terms-conditions")}
        </Link>
      </Label>
    </>
  );
});
